import { LayoutDataType } from '../../types';

export const ILLNESS_OPTIONS: {
  id: NonNullable<LayoutDataType['illness']>;
  title: string;
  emoji: string;
}[] = [
  {
    id: 'learn_wild',
    title: 'Learn the ways of the wild together',
    emoji: '🏹',
  },
  {
    id: 'explore_paths',
    title: 'Explore hidden paths',
    emoji: '🌲',
  },
  {
    id: 'sit_by_fire',
    title: 'Sit together by the fire',
    emoji: '🔥',
  },
  {
    id: 'connect_nature',
    title: 'Connect with nature',
    emoji: '🌿',
  },
  {
    id: 'moonlight',
    title: 'Get lost under the moonlight',
    emoji: '🌙',
  },
];
